var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lightbulb"},on:{"click":function($event){$event.preventDefault();return _vm.toggleDarkMode.apply(null, arguments)}}},[_c('svg',[_c('use',{attrs:{"href":require("../assets/icons.svg") + "#bulb"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }